import React, { useState, useEffect } from 'react';
import { BASE_URL, instanceAxios, GetCilentIp } from "../../config";
import { toast } from "react-toastify";
import FileUploadRegister from './FileUploadControl';
export default function Register(props) {
    const [pic_profile, Setpic_profile] = useState();
    const [Familly , SetFamilly] = useState('');
    const [Email, SetEmail] = useState('');
    const [Phone, SetPhone] = useState('');
    const [Password, SetPassword] = useState('');
    const [PasswordConfrim, SetPasswordConfrim] = useState('');
    
    const SaveRegister = () => { 
       
        let config = {
            mode: 'cors',
            method: 'post',
            url: `${BASE_URL}/UserInfo.ashx`,
            headers: {
                Accept: "application/json",
            },
            data: JSON.stringify({
                Method: 'Insert',
                Familly: Familly,
                picProfile: '',
                Email: Email,
                Phone: Phone,
                Password: Password,
                ClientIp: '',
                Id: props.UserId
            })
        };
        instanceAxios(config)
            .then(function (response) {
                if (response.status === 200) {
                    if (props.RegisterUserId === '') {
                        toast.success("با موفقیت  ثبت شد", {
                            closeButton: true,
                            autoClose: 1500
                        });
                        
                    }
                    else {
                        toast.info("با موفقیت  ویرایش شد", {
                            closeButton: true,
                            autoClose: 1500
                        });

                    }
                    setTimeout(props.SetShowModal(false), 3000);
                }
            })
            .catch((err) => {
                toast.warning(err.response ? 'بروز خطا' + err ?.response ?.data ?.msg : 'بروز خطا' + err.message, {
                    closeButton: false,
                    autoClose: 1500
                });
            })
        
    }

    const GetListData = () => {
        let config = {
            mode: 'cors',
            method: 'post',
            url: `${BASE_URL}/UserInfo.ashx`,
            headers: {
                Accept: "application/json",
            },
            data: JSON.stringify({
                Method: 'GetList',
                Id: props.UserId
            })
        };
        instanceAxios(config)
            .then(function (response) {
                if (response.status === 200 && response.data.length != 0) {                   
                    Setpic_profile(response.data[0].picProfile);
                    SetFamilly(response.data[0].Familly);
                    SetEmail(response.data[0].Email);
                    SetPhone(response.data[0].Phone);
                    SetPassword(response.data[0].Password);
                    SetPasswordConfrim(response.data[0].Password);
                }                   
            })
            .catch((err) => {

            })

    }

    useEffect(() => {
       props.UserId !== '' && GetListData();
    }, [props.UserId])
    return (
        <div className="modal"  style={{ display: props.showModal === true ? "block" : "none" }}>
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">افزودن کاربر</h5>
                        <button type="button" className="btn-close btn btn-danger" onClick={() => props.SetShowModal(false)} data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="form-group has-feedback">
                                <input type="text" className="form-control" value={Familly} onChange={(e) => SetFamilly(e.target.value)} placeholder="نام و نام خانوادگی" style={{ fontSize: "14px" }} />
                                <i className="icon ion-person form-control-feedback" style={{ fontSize: "30px" }}></i>
                            </div>
                            <div className="form-group has-feedback">
                                <input type="tel" className="form-control" value={Phone} onChange={(e) => SetPhone(e.target.value)} pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}" placeholder="شماره همراه" style={{ fontSize: "14px", direction: "rtl" }} />
                                <i className="icon ion-ios-telephone-outline form-control-feedback" style={{ fontSize: "30px" }}></i>
                            </div>
                            <div className="form-group has-feedback">
                                <input type="email" className="form-control" value={Email} onChange={(e) => SetEmail(e.target.value)} placeholder="ایمیل" style={{ fontSize: "14px", direction: "rtl" }} />
                                <i className="icon ion-ios-email-outline form-control-feedback" style={{ fontSize: "30px" }}></i>
                            </div>
                            <div className="form-group has-feedback">
                                <input type="password" className="form-control" value={Password} onChange={(e) => SetPassword(e.target.value)} placeholder="رمز عبور" style={{ fontSize: "14px" }} />
                                <i className="icon ion-ios-locked-outline form-control-feedback" style={{ fontSize: "30px" }}></i>
                            </div>
                            <div className="form-group has-feedback">
                                <input type="password" className="form-control" value={PasswordConfrim} onChange={(e) => SetPasswordConfrim(e.target.value)} placeholder="تکرار رمز عبور" style={{ fontSize: "14px" }} />
                                <i className="icon ion-ios-locked-outline form-control-feedback" style={{ fontSize: "30px" }}></i>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer float-start">
                        <button type="button" onClick={(e) => SaveRegister()} className="btn btn-success pull-right" style={{ marginRight: "10px", fontSize: "14px", width: "80px" }}>
                            ارسال
                        </button>
                        <button type="button" className="btn btn-danger pull-right" data-bs-dismiss="modal" style={{ marginRight: "10px", fontSize: "14px", width: "80px" }} onClick={() => props.SetShowModal(false)}>بستن</button>
                    </div>
                </div>
            </div>
        </div>

    );
} 
